<template>
  <div class="home">
    <home-tag :tag="'top'" :tagTitle="'home.tag.top'" />
    <home-hero />
<!--    <home-feedbacks />-->
    <home-categories />
    <home-tag :tag="'best'" :tagTitle="'home.tag.best'" />
    <home-info />
  </div>
</template>

<script setup>
import HomeHero from "@/components/home/home-hero.vue";
import HomeTag from "@/components/home/home-tag.vue";
import HomeCategories from "@/components/home/home-categories.vue";
import HomeInfo from "@/components/home/home-info.vue";
import {useRoute} from "vue-router";
import {computed, onMounted} from "vue";
import {Auth} from "@/core/api/auth.js";
import {ElNotification} from "element-plus";
import {useI18n} from "vue-i18n";
// import HomeFeedbacks from "@/components/home/home-feedbacks.vue";

const route = useRoute()
const {t} = useI18n()

const token = computed(() =>
    route.query.token ? (route.query.token) : undefined,
);
const uid = computed(() =>
    route.query.uid ? (route.query.uid) : undefined,
);
const payment = computed(() =>
    route.query.payment ? (route.query.payment) : undefined,
);

const activateAccount = async () => {
  if (token.value && uid.value && route.name === "activate-user") {
    const res = await Auth.activateUser(token.value, uid.value)

    if (res.data.activateUser) {
      ElNotification({
        message: t("popup.activateSuccess"),
        type: "success"
      });
    } else {
      ElNotification({
        message: res.errors[0].message,
        type: "error"
      });
    }
  }
};

onMounted(async () => {
  await activateAccount();

  switch (payment.value) {
    case "processing":
      ElNotification({
        message: t("popup.paymentProcessing"),
        type: "success"
      });

      break

    case "success":
      ElNotification({
        message: t("popup.paymentSuccess"),
        type: "success"
      });

      break

    case "cancel":
      ElNotification({
        message: t("popup.paymentCancel"),
        type: "error"
      });

      break

    default:
      console.log('')
  }
});
</script>

<style lang="scss" scoped>
.home {
  padding-top: 100px;
}
</style>